import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUsersPage } from './admin-users';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminUsersPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUsersPage),
    DirectivesModule  
  ],
})
export class AdminUsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.module.ts